import { useRef } from 'react';

import { IconButton, IconButtonProps } from '@components/icon-button';
import { IconDownload } from '@components/icons/download';
import { VisuallyHidden } from '@components/visually-hidden';

export type DownloadButtonProps = {
  url?: string;
  variant?: IconButtonProps['variant'];
  base64File?: {
    filename: string;
    href: string;
  };
};

export const DownloadButton = ({
  url,
  variant = 'secondary-purple',
  base64File,
}: DownloadButtonProps) => {
  const anchorRef = useRef<HTMLAnchorElement>(null);

  if (!url && !base64File) return null;

  return (
    <>
      <VisuallyHidden>
        {base64File ? (
          <a
            ref={anchorRef}
            rel="noopener noreferrer"
            target="_blank"
            download={base64File.filename}
            href={base64File.href}
          >
            {base64File.filename}
          </a>
        ) : (
          <a ref={anchorRef} rel="noopener noreferrer" target="_blank" href={url}>
            {url}
          </a>
        )}
      </VisuallyHidden>
      <IconButton
        variant={variant}
        icon={<IconDownload />}
        onClick={() => anchorRef.current?.click()}
      />
    </>
  );
};
